import { Component, Input, OnInit } from '@angular/core';
import { PiggyTransactionType } from 'src/app/shared-lib/domains/piggy';
import { ProductStore } from 'src/app/shared-lib/domains/product';
import { OrderTypeStatus } from '../../shared-lib/domains/order';

@Component({
  selector: 'app-ambassador-products-table',
  templateUrl: './ambassador-products-table.component.html',
  styleUrls: ['./ambassador-products-table.component.scss'],
  standalone: false
})
export class AmbassadorProductsTableComponent implements OnInit {

  @Input() ambassadorProducts: Array<ProductStore>;
  @Input() userId;
  constructor() { }

  ngOnInit() { }

  protected readonly PiggyTransactionType = PiggyTransactionType;
  protected readonly OrderTypeStatus = OrderTypeStatus;
}

